module.exports = __webpack_public_path__ + "static/media/details.9f36bdb5.svg";